"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = void 0;
const styles_1 = require("@mui/material/styles");
const button_1 = __importDefault(require("../button"));
exports.StyledButton = (0, styles_1.styled)(button_1.default)(() => ({
    textDecoration: "underline",
    "&:hover": {
        textDecoration: "underline"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dlb2xvY2F0aW9uLWJ1dHRvbi9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLHVEQUErQjtBQUVsQixRQUFBLFlBQVksR0FBRyxJQUFBLGVBQU0sRUFBQyxnQkFBTSxDQUFDLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQztJQUNoRCxjQUFjLEVBQUUsV0FBVztJQUMzQixTQUFTLEVBQUU7UUFDVCxjQUFjLEVBQUUsV0FBVztLQUM1QjtDQUNGLENBQUMsQ0FBQyxDQUFDIn0=